import { render, staticRenderFns } from "./topics.vue?vue&type=template&id=81322770&scoped=true"
import script from "./topics.vue?vue&type=script&lang=js"
export * from "./topics.vue?vue&type=script&lang=js"
import style0 from "./topics.vue?vue&type=style&index=0&id=81322770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81322770",
  null
  
)

export default component.exports